import { IonContent } from '@ionic/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { S3_BUCKET_URL } from '@/constants';
import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  ContentSection,
  LogoSection,
  PageStyles,
  StoresLinks,
} from './Maxim.styles';

const MaximVariant: React.FC = () => {
  const { user } = useAccount();
  const downloadingAppLink = 'https://dialogue-ai.onelink.me/pRfx/d7lbe3c5';

  const fireAmplitude = (storeType: string) => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('download_click', {
        type: storeType,
      });
    }
  };

  // Get outfit from user onboarding_data, default to 'tank-top'
  const outfit = user?.onboarding_data?.outfit || 'Tank Top';
  const outfitId = outfit === 'Jacket' ? 'jacket' : 'top-tank';
  const backgroundImage = `${S3_BUCKET_URL}/success-page/maxim/${outfitId}.png`;

  return (
    <PageStyles
      background="dark-solid"
      bgImage={<img src={backgroundImage} alt="Maxim" />}
    >
      <IonContent>
        <ContentSection>
          <LogoSection>
            <LogoWithAppName withCaption={false} />
            <UiTypography
              variant="title-large"
              align="center"
              className="dialogue-text"
            >
              On Dialogue App, we can
              <br /> chat 24/7 with no limits
            </UiTypography>
          </LogoSection>

          <StoresLinks>
            <a
              href={downloadingAppLink}
              onClick={() => fireAmplitude('appstore')}
            >
              <img
                src={`${S3_BUCKET_URL}/onboarding/appstore.png`}
                alt="appstore"
              />
            </a>
            <a
              href={downloadingAppLink}
              onClick={() => fireAmplitude('googleplay')}
            >
              <img
                src={`${S3_BUCKET_URL}/onboarding/googleplay.png`}
                alt="googleplay"
              />
            </a>
          </StoresLinks>
        </ContentSection>
      </IonContent>
    </PageStyles>
  );
};

export default MaximVariant;
